module.exports = __webpack_public_path__ + "static/media/sessionExpired.377403c3.png";